import "../../pages/order-form/OrderForm.css";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import { Button } from "@app/components";
import * as Yup from 'yup';
import { useFormik } from "formik";
import { getAllActiveFranchise, getAllActiveFranchiseWithGroup } from "@app/services/franchise";
import { useDispatch, useSelector } from "react-redux";
import { loadCart, setFranchise, setStep, updateDefaultOrderLoadFlag, updateLaunchpackOrderLoadFlag, updateOrderType } from "@app/store/reducers/order";
import { getCartItemsByFranchise, loadDefaultOrder, loadLaunchpackOrder } from "@app/services/order";

const OrderFormStep1 = () => {

    let obj: any = {}
    const selectRef = useRef(null);
	const [franchises, setFranchises] = useState([]);
	const [linkedFranchises, setLinkedFranchises] = useState('');
	const [selectedFranchise, setSelectedFranchise] = useState(obj);
	const [isLoadingFranchise, setLoadingFranchise] = useState(false);
    const [isCartLoading, setCartLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate()
	const canAccess = useSelector((state: any) => state.auth.permissions.orders);

	useEffect(() => {
        dispatch(setStep(1));
		// getAllActiveFranchiseData();
    },[]);

	const getCartItemsByFranchiseData = async (franchiseId) => {
        try {
            // setLoadingFranchise(true);
            const resp = await getCartItemsByFranchise(franchiseId);
            if (resp?.success === true) {
				dispatch(loadCart(resp?.collections));
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            // setLoadingFranchise(false);
            toast.error(error?.message || 'Internal Server Error')
        }
    };

	const { handleChange, values, handleSubmit, touched, errors, setFieldValue} = useFormik({
        initialValues: {
            type: '',
            franchise_id: '',
            defaultOrder: false,
            launchpackOrder: false,
        },
        validationSchema: Yup.object({
            type: Yup.string().required('Please select order type'),
            franchise_id: Yup.string().required('Please select franchise'),
        }),
        onSubmit: (values) => {
			// dispatch(setFranchise(selectedFranchise));
            let franchiseId = selectedFranchise?.is_group_franchise ? (selectedFranchise?.id).split('-')[0] : selectedFranchise?.id
            dispatch(setFranchise({
                id: franchiseId, 
                name: selectedFranchise?.name, 
                franchise_type: selectedFranchise?.franchise_type, 
                phone: selectedFranchise?.franchise_phone, 
                address: selectedFranchise?.franchise_address, 
                enabled_material_orders: selectedFranchise?.enabled_material_orders,
                is_group_franchise: selectedFranchise?.is_group_franchise ?? false,
                group_id: selectedFranchise?.group_id
            }))
            dispatch(updateDefaultOrderLoadFlag({isDefaultOrderLoad: values.defaultOrder}))
            dispatch(updateLaunchpackOrderLoadFlag({isLaunchpackOrderLoad: values.launchpackOrder}))
            dispatch(updateOrderType({type: values.type}))

            if(values.type == 'consolidated'){
                navigate('/proposed-material-orders')
            }else{
                dispatch(setStep(2));
            }
        }
    });

    const getAllActiveFranchiseData = async (type) => {
        try {
            setLoadingFranchise(true);
            const resp = await ((type == 'consolidated') ? getAllActiveFranchiseWithGroup() : getAllActiveFranchise())
            setFieldValue('franchise_id', '')
            setLinkedFranchises('')
            if (resp?.success === true) {
                if(type == 'consolidated'){
                    resp?.collections.map((obj) => {
                        if(obj?.is_group_franchise){
                            obj.id =  obj?.id + '-' + obj?.group_id
                            obj.name =  obj?.name + ' (Default Franchise)'
                        }
                    })
                }
                setLoadingFranchise(false);
                setFranchises(resp?.collections);
            } else {
                setLoadingFranchise(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoadingFranchise(false);
            toast.error(error?.message || 'Internal Server Error')
        }
    };

	return (
		<>
			<div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card card-primary">
                            <form onSubmit={handleSubmit}>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1"><b>Order Type</b> <span className="required">*</span></label>
                                                <div className="custom-control custom-radio" key="material">
                                                    <input className="custom-control-input" type="radio" id="customRadio2" 
                                                        name="type" 
                                                        value="material" 
                                                        onChange={(e) => {
                                                            handleChange
                                                            setFieldValue("type", e.target.value)
                                                            getAllActiveFranchiseData('material')
                                                            selectRef.current.setValue('')
                                                        }}
                                                        checked={values.type === 'material'} 
                                                    />
                                                    <label htmlFor="customRadio2" className="custom-control-label">Material Order</label>
                                                </div>
                                                <div className="custom-control custom-radio" key="consolidated">
                                                    <input className="custom-control-input" type="radio" id="customRadio1" 
                                                        name="type" 
                                                        value="consolidated" 
                                                        onChange={(e) => {
                                                            handleChange
                                                            setFieldValue("type", e.target.value)
                                                            setFieldValue("defaultOrder", false)
                                                            setFieldValue("launchpackOrder", false)
                                                            getAllActiveFranchiseData('consolidated')
                                                        }} 
                                                        checked={values.type === 'consolidated'}
                                                    />
                                                    <label htmlFor="customRadio1" className="custom-control-label">Consolidated Order</label>
                                                </div>
                                                {(touched.type && errors.type) && (
                                                    <div className="text-danger">
                                                        {errors.type}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="franchise_id"><b> Franchise </b><span className="required">*</span></label>
                                                <Select
                                                    // className="form-control"
                                                    ref={selectRef}
                                                    name="franchise_id"
                                                    placeholder="Select Franchise"
                                                    options={franchises}
                                                    getOptionValue={(option)=>`${option['id']}`}
                                                    getOptionLabel={(option)=>`${option['name']}`}
                                                    onChange={ (option) => { 
														handleChange
                                                        setFieldValue("defaultOrder", false)
                                                        setFieldValue("launchpackOrder", false)
                                                        if(option){
                                                            setFieldValue("franchise_id", option.id)
															setSelectedFranchise(option)
                                                            if(values.type === 'consolidated'){
                                                                setLinkedFranchises((option?.group_franchises).length > 0 ? ( Array.prototype.map.call(option?.group_franchises, function(franchise) { return franchise.name; }).join(", ") ) : '') 
                                                            }
                                                        }else{
                                                            setFieldValue("franchise_id", '')
															setSelectedFranchise({})
                                                            setLinkedFranchises('')
                                                        }
                                                    }}
                                                    isLoading={isLoadingFranchise}
                                                    isClearable={true}
                                                />
                                                <span className='text-muted'> { linkedFranchises }</span>
                                                {(touched.franchise_id && errors.franchise_id) && (
                                                    <div className="text-danger">
                                                        {errors.franchise_id}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {values.type === 'material' && values.franchise_id && (
                                        <div className="row">
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <div className="icheck-primary">
                                                        <input type="checkbox"className="form-check-input" id="defaultOrder"  
                                                            onChange={(e) => { 
                                                                handleChange 
                                                                setFieldValue("defaultOrder", e.target.checked)
                                                            } }
                                                            disabled={values.launchpackOrder}
                                                        />
                                                        <label htmlFor="defaultOrder" className="form-check-label"><b> Do you want to load default order? </b></label>
                                                    </div>
                                                </div>
                                            </div>
                                            { canAccess['launchpack-order'] && !selectedFranchise?.launchpack_ordered && (
                                                <div className="col-sm-4">
                                                    <div className="form-group">
                                                        <div className="icheck-primary">
                                                            <input type="checkbox"className="form-check-input" id="launchpackOrder"  
                                                                onChange={(e) => { 
                                                                    handleChange 
                                                                    setFieldValue("launchpackOrder", e.target.checked)
                                                                } }
                                                                disabled={values.defaultOrder}
                                                            />
                                                            <label htmlFor="launchpackOrder" className="form-check-label"><b> Proceed with launchpack order? </b></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
								<div className="card-footer">
                                    <Button type="submit" className="btn btn-primary mr-2">Next </Button>
                                    <Link className="btn btn-default" to='/in-progress-orders'>Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
		</>
	);
};

export default OrderFormStep1;